import {useEffect, useState} from 'react'
import {getTotalNewMessage} from '@services/header/account'

const useTotalNewMessages = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [reload, setReload] = useState<boolean>(true)
  const [totalNewMessages, setTotalNewMessages] = useState<number>(0)

  const refetch = () => {
    setReload(true)
  }

  useEffect(() => {
    if (!reload) return

    setLoading(true)
    const abortController = new AbortController()
    let isMounted = true

    getTotalNewMessage({
      signal: abortController.signal,
    })
      .then((response: any) => {
        if (isMounted) {
          setTotalNewMessages(response ? response : 0)
        }
      })
      .catch((error: any) => {
        if (isMounted) {
          // openToastNotification({
          //   title: 'Có lỗi xảy ra, vui lòng thử lại sau.',
          //   type: 'error',
          // })
          console.log(error)
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false)
          setReload(false)
        }
      })

    return () => {
      isMounted = false
      abortController.abort()
    }
  }, [reload])

  return {
    loading,
    totalNewMessages,
    refetch,
  }
}

export default useTotalNewMessages

